/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-three-dots': {
    width: 10,
    height: 3,
    viewBox: '0 0 10 3',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 .769a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0z" _fill="#376F99"/>'
  }
})
